"use strict";
exports.__esModule = true;
exports.isFixedFooter = void 0;
var IDENTITY_IOS_LAYOUTS = ['ios_cx', 'ios_cx_caviar'];
// TODO: Investigate and replace this with enums.
// Failed other tests due to use of typescript enums here.
var FORGOT_PASSWORD_WORKFLOWS = [
    'forgot_password',
    'dx_forgot_password',
    'mx_forgot_password',
];
var DEFAULT_IDENTITY_IOS_LAYOUT = 'default';
var DASHER_IDENTITY_IOS_CLIENT_ID = '1649492812162361366';
/**
 * Identity supports webviews for mobile platforms. The fixed footer
 * position (required for mobile web) causes weird behavior for the iOS webview.
 * The suggestion from the Prism team is to switch off the fixed footer
 * positioning only on webviews.
 *
 * @param workflow type of workflow.
 * @returns whether the footer should be fixed in the modal.
 */
exports.isFixedFooter = function (workflow) {
    var clientId = window && window.Configuration && window.Configuration.clientId;
    var layout = window && window.Configuration && window.Configuration.layout;
    // Forgot password is web only hence we need the footer to be fixed always.
    if (workflow && FORGOT_PASSWORD_WORKFLOWS.includes(workflow)) {
        return true;
    }
    if (layout === DEFAULT_IDENTITY_IOS_LAYOUT &&
        clientId === DASHER_IDENTITY_IOS_CLIENT_ID) {
        return false;
    }
    return !IDENTITY_IOS_LAYOUTS.includes(layout);
};
